module.exports = poll => {
  const allData = [];

  Object.entries(poll.details).forEach(([key, value]) => {
    value.forEach(item => (item.choice = poll.choices[key]));
    allData.push(...value);
  });

  const headers = ["name", "email", "choice"];
  const headerString = headers.join(",");
  const dataString = allData.map(row => headers.map(header => row[header]).join(",")).join("\n");
  const fullString = `${headerString}\n${dataString}`;
  // download string  as csv
  const encodedUri = encodeURI("data:text/csv;charset=utf-8," + fullString);
  const link = document.createElement("a");
  link.setAttribute("href", encodedUri);
  link.setAttribute("download", `${encodeURIComponent(poll.question)}.csv`);
  document.body.appendChild(link); // Required for FF
  link.click();
  document.body.removeChild(link);
};
